<template>

  <div>
    <h2>Табель</h2>

    <div v-if="hasAccess(adminRoles)" class="row g-3">
      <div class="col-md-6">
        <button class="open-modal-btn" @click="openModal">Загрузить EXCEL табель</button>
        <i>Суммы в excel должны быть тип text и в формате 13547666.31 или 13547666,31</i>
        <br>
        <b>Порядок колонок важен</b>
        <p><a href="/templates/timesheet_example.xlsx">Чтобы скачать пример excel табеля - нажмите по этой строке</a></p>
      </div>
      <div class="col-md-6">
        <div>
          Загрузка Дошкольных Организации
          <br>
          В очереди: <b>{{rabbitQueue}}</b>
        </div>
        <ul></ul>
        <div>
          Предварительный расчет ФЦ по Дошкольным Организациям
          <br>
          В очереди: <b>{{rabbitQueuePreCalculationAmount}}</b>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <button type='button' class="btn btn-info me-3" @click="router.push('/timesheet/pre/calculation');">Перейти на предварительный расчет табеля</button>
      <button type='button' class="btn btn-info" @click="router.push('/timesheet/general');">Перейти на общий табель по ДО</button>
    </div>


    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h4>Выберите .xlsx файл для загрузки табеля</h4>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="timesheetType" class="form-label">Тип табеля</label>
            <div class="input-group">
              <multiselect
                  v-model="timesheetType"
                  :options="timesheetTypeList"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="formattedTimesheetTypeLabel"
                  placeholder="Выберите тип табеля"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="accountingMonth" class="form-label">Расчетный месяц</label>
            <div class="input-group">
              <input type="number" max="12" class="form-control" id="accountingMonth" required v-model="searchParams.accountingMonth">
            </div>
          </div>

          <div class="form-group">
            <label for="accountingYear" class="form-label">Расчетный год</label>
            <div class="input-group">
              <input type="number" min="2024" class="form-control" id="accountingYear" required v-model="searchParams.accountingYear">
            </div>
          </div>
          <div class="form-group">
            <label for="timesheetFile" class="form-label">Выберите .xlsx файл</label>
            <input type="file" id="timesheetFile" class="form-control" required accept=".xlsx" @change="handleFileUpload">
          </div>
          <div class="form-group">
            <button type="submit" class="submit-btn" :disable="isLoading">
              {{ isLoading ? 'Загружается...' : 'Загрузить' }}
            </button>
          </div>
        </form>
        <button class="close-modal-btn" @click="closeModal">Закрыть</button>
      </div>
    </div>

    <br>
    <br>


    <div class="row g-3">

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="timesheetType" class="form-label col-md-3">Тип табеля</label>
          <div class="col-md-9">
            <div class="input-group">
              <multiselect
                  v-model="timesheetType"
                  :options="timesheetTypeList"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="formattedTimesheetTypeLabel"
                  placeholder="Выберите тип табеля"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="bin" class="form-label col-md-3">БИН</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" class="form-control" id="bin" v-model="searchParams.bin">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="lmsId" class="form-label col-md-3">LMS ID</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" class="form-control" id="lmsId" v-model="searchParams.lmsId">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingMonth" class="form-label col-md-3">Расчетный месяц</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" max="12" class="form-control" id="accountingMonth" v-model="searchParams.accountingMonth">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingYear" class="form-label col-md-3">Расчетный год</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min="2024" class="form-control" id="accountingYear" v-model="searchParams.accountingYear">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <button class="btn btn-primary" @click="fetchTimesheetData" :disabled="fetchLoading">{{ !fetchLoading ? "Поиск" : "Загрузка..." }}</button>
          <label v-if="hasAccess(adminWriteRoles)" class="ms-3">
            <input type="checkbox" v-model="searchParams.includeDeleted"> Показать удалённые
          </label>
        </div>
      </div>
    </div>


    <div class="page-content-info d-flex align-items-center justify-content-end">
      <button :disabled = "(timesheetResponse.length === 0)" class="btn btn-info" @click="downloadGeneratedCalculationReportList()">Выгрузить
        результат по фильтру
      </button>
    </div>


    <div class="row">
      <div class="col-md-2"><span>Элементов: {{ timesheetResponse.length }}</span></div>
      <div v-if="hasAccess(adminRoles)" class="col-md-2"><span>Выбрано: {{ selectionTimesheetDataList.length }}</span></div>
      <div v-if="hasAccess(adminRoles)" class="col-md-6">
        <button v-if="selectedLive.length > 0" type="button" class="btn btn-danger" @click="showDeleteConfirmationModal = true">Удалить выбранные элементы ({{selectedLive.length}})</button>
        <button v-if="hasAccess(adminWriteRoles) && selectedDeleted.length > 0" type="button" class="btn btn-success ms-2" @click="showRestoreModal = true">Восстановить ({{selectedDeleted.length}})</button>
        <button v-if="hasAccess(adminWriteRoles) && timesheetsInResult.length > 0" type="button" class="btn btn-outline-danger ms-2" @click="showRemoveTimesheetModal = true">Удалить табель целиком{{ timesheetsInResult.length > 1 ? ` (${timesheetsInResult.length})` : "" }}</button>
      </div>
    </div>

    <DeleteReasonDialog v-model="showDeleteConfirmationModal" title="Вы точно хотите удалить выбранные строки из табеля?" :loading="fetchLoading" @confirm="handleDeleteSelectedElements">
      <p>Выбрано строк: {{ selectionTimesheetDataList.length }}. После удаления табель будет пересчитан.</p>
    </DeleteReasonDialog>
    <DeleteReasonDialog v-model="showRestoreModal" variant="restore" title="Восстановить выбранные строки табеля?" confirm-text="Восстановить" reason-label="Причина восстановления" :loading="fetchLoading" @confirm="handleRestoreSelectedElements">
      <p>Выбрано строк: {{ selectedDeleted.length }}. После восстановления табель будет пересчитан.</p>
    </DeleteReasonDialog>
    <DeleteReasonDialog v-model="showRemoveTimesheetModal" title="Удалить табель целиком?" confirm-text="Удалить табель" :loading="fetchLoading" @confirm="handleRemoveTimesheets">
      <p>Будут удалены безвозвратно все строки табеля (включая созданные расчётом и ранее удалённые), общие сведения и сам табель.
        Восстановить можно только повторной загрузкой из LMS. Подписанные расчёты за этот месяц не трогаются.</p>
      <ul>
        <li v-for="t in timesheetsInResult" :key="t.monthlyTimesheetId">
          {{ t.name }} (БИН {{ t.bin }}, LMS ID {{ t.lmsId }}), {{ searchParams.accountingMonth }}.{{ searchParams.accountingYear }} — строк: {{ t.rows }}
        </li>
      </ul>
    </DeleteReasonDialog>
    <el-table
        ref="multipleTableRef"
        @selection-change="handleSelectionChange"
        :data="timesheetResponse"
        :row-class-name="rowClassName"
        style="width: 100%"
        border
        height="95vh"
    >
      <el-table-column v-if="hasAccess(adminRoles)" type="selection"/>
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column label="Текст ошибки">
        <template #default="scope">
          <p style="color:red;">{{ scope.row.errorText }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="bin" label="БИН ДО"></el-table-column>
      <el-table-column prop="lmsId" label="LMS ID"></el-table-column>
      <el-table-column prop="arrivedDate" label="Прибытия"></el-table-column>
      <el-table-column prop="departureDate" label="Выбытия"></el-table-column>
      <el-table-column prop="regionGroup" label="Регион группа"></el-table-column>
      <el-table-column prop="localityType" label="Тип населенного пункта"></el-table-column>
      <el-table-column prop="regionType" label="Регион тип"></el-table-column>
      <el-table-column prop="ownershipType" label="Тип собственности"></el-table-column>
      <el-table-column prop="durationTime" label="Время прибывание"></el-table-column>
      <el-table-column prop="educationalType" label="Тип образование"></el-table-column>
      <el-table-column prop="timesheetType" label="Тип табеля"></el-table-column>
      <el-table-column prop="presenceDays" label="Дни прибывание"></el-table-column>
      <el-table-column prop="planningDays" label="Плановые дни"></el-table-column>
      <el-table-column prop="recalculationAmount" label="Сумма перерасчета LMS"></el-table-column>
      <el-table-column prop="preReconciliationSum" label="Сумма перерасчета ФЦ"></el-table-column>
      <el-table-column label="Сумма LMS">
        <template #default="scope">
          <p
              :class="{
                'text-danger': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) > 1000,
                'text-warning': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) < 1000 && Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) > 0,
                'text-success': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) == 0,
              }"
          >
            {{ scope.row.totalToAccrueLms }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Предварительный расчет ФЦ">
        <template #default="scope">
          <p
              :class="{
                'text-danger': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) > 1000,
                'text-warning': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) < 1000 && Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) > 0,
                'text-success': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) == 0,
              }"
          >
            {{ scope.row.preCalculationAmount }}
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="voucherType" label="Ваучер"></el-table-column>

      <el-table-column prop="name" label="Название ДО"></el-table-column>
      <el-table-column prop="lmsName" label="Название LMS"></el-table-column>
      <el-table-column prop="totalDaysOnMonth" label="Дни в месяце"></el-table-column>
      <el-table-column prop="workingDays" label="Рабочие дни"></el-table-column>
      <el-table-column prop="weekendDays" label="Выходные дни"></el-table-column>
      <el-table-column prop="childIin" label="ИИН ребенка"></el-table-column>
      <el-table-column prop="passportNumber" label="Паспорт ребенка"></el-table-column>
      <el-table-column prop="childFirstName" label="Имя ребенка"></el-table-column>
      <el-table-column prop="childLastName" label="Фамилия"></el-table-column>
      <el-table-column prop="childMiddleName" label="Отчество"></el-table-column>
      <el-table-column prop="parentIin" label="ИИН родителя"></el-table-column>
      <el-table-column prop="parentFirstName" label="Имя родителя"></el-table-column>
      <el-table-column prop="parentLastName" label="Фамилия"></el-table-column>
      <el-table-column prop="parentMiddleName" label="Отчество"></el-table-column>
      <el-table-column prop="phoneNumber" label="Телефона"></el-table-column>
      <el-table-column prop="escrowAccount" label="escrowAccount"></el-table-column>
      <el-table-column prop="excusedAbsenceDays" label="Отсутствие с причиной"></el-table-column>
      <el-table-column prop="unexcusedAbsenceDays" label="Отсутствие без причины"></el-table-column>
      <el-table-column prop="sickLeaveDays" label="Больничные дни"></el-table-column>
      <el-table-column prop="haveSickLeave" label="haveSickLeave"></el-table-column>
      <el-table-column prop="matchSickLeavePeriod" label="matchSickLeavePeriod"></el-table-column>
      <el-table-column prop="vacationDays" label="Дни отпуска"></el-table-column>
      <el-table-column prop="isVacationStatement" label="isVacationStatement"></el-table-column>
      <el-table-column prop="matchVacationPeriod" label="matchVacationPeriod"></el-table-column>
      <el-table-column prop="isAgreed" label="Согласован"></el-table-column>
      <el-table-column prop="consentDate" label="Дата согласование"></el-table-column>
      <el-table-column prop="approverIin" label="ИИН согласующего"></el-table-column>
      <el-table-column prop="approverFirstName" label="Имя"></el-table-column>
      <el-table-column prop="approverLastName" label="Фамилия"></el-table-column>
      <el-table-column prop="approverMiddleName" label="Отчество"></el-table-column>
      <el-table-column prop="absenceRedLine" label="БП более 40 дней"></el-table-column>
      <el-table-column prop="lmsDocumentId" label="Lms Document Id"></el-table-column>
      <el-table-column prop="lmsChildId" label="Lms Child Id"></el-table-column>
      <el-table-column prop="createdBy" label="Created by"></el-table-column>
      <el-table-column prop="seats" label="Сколько место занимает контингент"></el-table-column>
    </el-table>

  </div>

</template>

<script lang="ts">
import {defineComponent, onMounted, ref, computed} from "vue";
import {
  getPreCalculationAmountRabbitQueue,
  getTimesheetUploadingQueue,
  uploadTimesheetXlsx,
} from "@/services/lmsService";
import {ElMessage} from "element-plus";
import DeleteReasonDialog from "@/components/DeleteReasonDialog.vue";
import {extractApiError} from "@/utils/apiError";
import authService from "@/services/authService";
import {useRouter} from "vue-router";
import {SearchParam} from "@/types/searchParam";
import {deleteSelectedTimesheetData, getFullTimesheetDetail, removeMonthlyTimesheets, restoreSelectedTimesheetData} from "@/services/kindergartenService";
import {KindergartenTimesheetData, TimesheetType} from "@/types/kindergarten";
import {getGeneratedTimesheetList} from "@/services/reportService";
import cacheService from "@/services/cacheService";
import Multiselect from "vue-multiselect";

export default defineComponent({
  name: "TimesheetView",
  components: {Multiselect, DeleteReasonDialog},
  setup() {
    const showModal = ref(false);
    const isLoading = ref(false);
    const fetchLoading = ref(false);
    const uploadedFile = ref<any>();
    const rabbitQueue = ref<number>();
    const rabbitQueuePreCalculationAmount = ref<number>();
    const searchParams = ref({
      bin: "",
      lmsId: "",
      accountingMonth: new Date().getMonth() + 1,
      accountingYear: new Date().getFullYear(),
      includeDeleted: false,
    });
    const timesheetResponse = ref<KindergartenTimesheetData[]>([]);
    const selectionTimesheetDataList = ref<KindergartenTimesheetData[]>([]);
    const showDeleteConfirmationModal = ref(false);
    const showRestoreModal = ref(false);
    const showRemoveTimesheetModal = ref(false);
    const adminWriteRoles: string[] = authService.getAdminWriteRoles();
    /** Табели, попавшие в результат поиска (обычно один): для кнопки «Удалить табель целиком». */
    const timesheetsInResult = computed(() => {
      const byId = new Map<string, { monthlyTimesheetId: string; name: string; bin: string; lmsId: string; rows: number }>();
      timesheetResponse.value.forEach((r: KindergartenTimesheetData) => {
        const current = byId.get(r.monthlyTimesheetId);
        if (current) {
          current.rows += 1;
        } else {
          byId.set(r.monthlyTimesheetId, { monthlyTimesheetId: r.monthlyTimesheetId, name: r.name, bin: r.bin, lmsId: r.lmsId, rows: 1 });
        }
      });
      return Array.from(byId.values());
    });
    const handleRemoveTimesheets = async (reason: string) => {
      if (timesheetsInResult.value.length === 0) return;
      fetchLoading.value = true;
      try {
        await removeMonthlyTimesheets(timesheetsInResult.value.map((t) => t.monthlyTimesheetId), reason);
        ElMessage({ message: "Табель удалён. Садик может заново прислать месяц из LMS.", type: "success", showClose: true });
        timesheetResponse.value = [];
        selectionTimesheetDataList.value = [];
        showRemoveTimesheetModal.value = false;
      } catch (error) {
        ElMessage({ message: extractApiError(error, "Удаление табеля не прошло"), type: "error", showClose: true });
      }
      fetchLoading.value = false;
    };
    const selectedLive = computed(() => selectionTimesheetDataList.value.filter((r: KindergartenTimesheetData) => !r.deletion));
    const selectedDeleted = computed(() => selectionTimesheetDataList.value.filter((r: KindergartenTimesheetData) => !!r.deletion));
    const rowClassName = ({ row }: { row: KindergartenTimesheetData }) => (row.deletion ? "deleted-row" : "");

    const handleRestoreSelectedElements = async (reason: string) => {
      if (selectedDeleted.value.length > 0) {
        fetchLoading.value = true;
        try {
          await restoreSelectedTimesheetData(selectedDeleted.value[0].monthlyTimesheetId, selectedDeleted.value.map((it: KindergartenTimesheetData) => it.monthlyTimesheetDatasetId), reason);
          location.reload();
          return;
        } catch (error) {
          ElMessage({ message: extractApiError(error, "Восстановление не прошло"), type: "error", showClose: true });
        }
        fetchLoading.value = false;
        showRestoreModal.value = false;
      }
    };
    const timesheetType = ref<TimesheetType | null>(null);
    const timesheetTypeList = ref<TimesheetType[]>([]);

    const adminRoles: string[] = authService.getAdminRoles();
    const hasAccess = authService.hasAccess;
    const router = useRouter();

    const fetchCachedData = async () => {
      timesheetTypeList.value = await cacheService.useTimesheetType().fetchTimesheetType();
      timesheetType.value = timesheetTypeList.value.find(item => item.code === 1) || null;
    };

    const openModal = () => {
      showModal.value = true;
    };
    const closeModal = () => {
      showModal.value = false;
    };

    const handleSubmit = () => {
      try {
        if (uploadedFile.value) {
          isLoading.value = true;
          const formData = new FormData();
          formData.append('file', uploadedFile.value);
          const timesheetTypeCode = timesheetType.value?.code;
          const accountingMonth = searchParams.value.accountingMonth;
          const accountingYear = searchParams.value.accountingYear;
          if (timesheetTypeCode && accountingMonth && accountingYear) {
            uploadTimesheetXlsx(formData, timesheetTypeCode, accountingMonth, accountingYear).then(() => {
              isLoading.value = false;
              window.location.reload();
            }).catch((error) => {
              if (error.status === 400) {
                ElMessage({
                  message: error.response.data,
                  type: 'error',
                  duration: 0,
                  showClose: true,
                });
              }
              isLoading.value = false;
            })
          }
        }
      } catch(error) {
        isLoading.value = false;
        console.error(error);
      }
    }

    const downloadGeneratedCalculationReportList = async () => {
      try {
        isLoading.value = true;
        const searchParamResponse = new SearchParam(
            0,
            0,
            {
              "bin": searchParams.value.bin,
              "lmsId": searchParams.value.lmsId,
              "accountingMonth": searchParams.value.accountingMonth,
              "accountingYear": searchParams.value.accountingYear,
              "timesheetType": timesheetType.value?.code
            },
            {}
        );

        await getGeneratedTimesheetList(searchParamResponse);
        isLoading.value = false;
      } catch (error) {
        isLoading.value = false;
        console.error(error);
      }
    }

    const fetchTimesheetRabbitQueue = async () => {
      try {
        rabbitQueue.value = await getTimesheetUploadingQueue();
      } catch (error) {
        console.error(error);
      }
    }

    const fetchPreCalculationAmountRabbitQueue = async () => {
      try {
        rabbitQueuePreCalculationAmount.value = await getPreCalculationAmountRabbitQueue();
      } catch (error) {
        console.error(error);
      }
    }

    const handleFileUpload = (event: any) => {
      uploadedFile.value = event.target.files[0];
    }

    const fetchTimesheetData = async () => {
      try {
        if (searchParams.value.bin == "" && searchParams.value.lmsId == "") {
          ElMessage.warning("Укажите БИН ДО или LMS ID");
          return;
        }
        fetchLoading.value = true;
        const searchParamResponse = new SearchParam(
            0,
            0,
            {
              "bin": searchParams.value.bin,
              "lmsId": searchParams.value.lmsId,
              "accountingMonth": searchParams.value.accountingMonth,
              "accountingYear": searchParams.value.accountingYear,
              "timesheetType": timesheetType.value?.code,
              "includeDeleted": searchParams.value.includeDeleted
            },
            {}
        );
        timesheetResponse.value = await getFullTimesheetDetail(searchParamResponse);
        fetchLoading.value = false;
      } catch(error) {
        fetchLoading.value = false;
        console.error(error);
      }
    };

    const handleSelectionChange = (val: KindergartenTimesheetData[]) => {
      selectionTimesheetDataList.value = val;
    };

    const handleDeleteSelectedElements = async (reason: string) => {
      if (selectionTimesheetDataList.value.length > 0) {
        fetchLoading.value = true;
        try {
          const responseStatus = await deleteSelectedTimesheetData(selectedLive.value[0].monthlyTimesheetId, selectedLive.value.map((it: KindergartenTimesheetData) => it.monthlyTimesheetDatasetId), reason);
          if (responseStatus === 200) {
            location.reload();
            return;
          }
          ElMessage({ message: "Неизвестная ошибка, удаление не прошло", type: "error", showClose: true });
        } catch (error) {
          ElMessage({ message: extractApiError(error, "Удаление не прошло"), type: "error", showClose: true });
        }
        fetchLoading.value = false;
        closeDeleteConfirmationModal();
      }
    }

    const closeDeleteConfirmationModal = () => {
      showDeleteConfirmationModal.value = false;
    }

    const formattedTimesheetTypeLabel = (item: any) => {
      return `${item.code} | ${item.name}`;
    }

    onMounted(() => {
      fetchTimesheetRabbitQueue();
      fetchPreCalculationAmountRabbitQueue();
      fetchCachedData();
    });

    return {
      timesheetType,
      timesheetTypeList,
      showModal,
      isLoading,
      fetchLoading,
      rabbitQueue,
      rabbitQueuePreCalculationAmount,
      adminRoles,
      router,
      searchParams,
      timesheetResponse,
      selectionTimesheetDataList,
      showDeleteConfirmationModal,
      showRestoreModal,
      adminWriteRoles,
      selectedLive,
      selectedDeleted,
      rowClassName,
      handleRestoreSelectedElements,
      formattedTimesheetTypeLabel,
      hasAccess,
      openModal,
      closeModal,
      handleSubmit,
      handleFileUpload,
      fetchTimesheetData,
      handleSelectionChange,
      handleDeleteSelectedElements,
      showRemoveTimesheetModal,
      timesheetsInResult,
      handleRemoveTimesheets,
      downloadGeneratedCalculationReportList,
    }
  }
});
</script>

<style scoped>
.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}
</style>

<style>
.el-table .deleted-row {
  background-color: #fdecea;
  color: #8a8a8a;
}
</style>
